var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "appear": "",
      "name": "fade",
      "enter-active-class": _vm.theme.fadeEnterActive,
      "enter-class": _vm.theme.fadeEnter,
      "enter-to-class": _vm.theme.fadeEnterTo,
      "leave-active-class": _vm.theme.fadeLeaveActive,
      "leave-class": _vm.theme.fadeLeave,
      "leave-to-class": _vm.theme.fadeLeaveTo
    }
  }, [(_vm.active) ? _c('div', {
    class: _vm.theme.wrapper,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  }, [_c('div', {
    class: _vm.classes,
    on: {
      "mouseleave": _vm.handleBlur,
      "mouseenter": _vm.handleFocus
    }
  }, [_vm._t("default")], 2)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fbeb8ce","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Modal/Modal.vue
// module id = 584
// module chunks = 0